'use strict';

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormField = require('./FormField');

var _reduxForm = require('redux-form');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var GetFieldValuesError = function GetFieldValuesError(props, context) {
  console.log('PROPS & CONTEXT', props, context);
  var data = {};
  var errors = {};
  var requestedFields = {};
  var names = props.names,
      formValues = props.formValues,
      syncErrors = props.syncErrors;
  var mode = context.mode,
      values = context.values,
      fields = context.fields,
      namePrefix = context.namePrefix;
  var allValues = void 0,
      allErrors = void 0;

  if (mode === "display") {
    allValues = values;
    allErrors = [];
  } else {
    allValues = formValues;
    allErrors = syncErrors;
  }

  names.forEach(function (name) {
    data[name] = allValues && (0, _FormField.getField)(allValues, name, namePrefix);
    requestedFields[name] = (0, _FormField.getField)(fields, name, namePrefix);
    errors[name] = allErrors && (0, _FormField.getField)(allErrors, name, namePrefix);
  }); // TODO: Add clone with added value props for childred
  // TODO: Add child function

  return props.renderValues(_extends({
    values: data,
    errors: errors,
    fields: requestedFields
  }, props));
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var name = ownProps.name;
  console.log('Form Name=', name);
  return {
    syncErrors: (0, _reduxForm.getFormSyncErrors)(name)(state),
    formValues: (0, _reduxForm.getFormValues)(name)(state)
  };
};

GetFieldValuesError = (0, _reactRedux.connect)(mapStateToProps)(GetFieldValuesError); // TODO: Maybe default of all field and values?

GetFieldValuesError.propTypes = {
  names: _propTypes2["default"].arrayOf(_propTypes2["default"].string).isRequired,
  renderValues: _propTypes2["default"].func.isRequired
};
GetFieldValuesError.contextTypes = {
  mode: _propTypes2["default"].string,
  fields: _propTypes2["default"].object,
  values: _propTypes2["default"].object,
  namePrefix: _propTypes2["default"].string
};

var FieldValues = function FieldValues(props, _ref) {
  var formName = _ref.formName;
  return _react2["default"].createElement(GetFieldValuesError, _extends({}, props, {
    name: formName
  }));
};

FieldValues.contextTypes = {
  formName: _propTypes2["default"].string
};
FieldValues.propTypes = {
  names: _propTypes2["default"].arrayOf(_propTypes2["default"].string).isRequired,
  renderValues: _propTypes2["default"].func.isRequired
};
exports["default"] = FieldValues;